import { toast } from 'react-toastify'
import { GeolocationStatus } from '../constants'
import cookie from 'js-cookie'

export const getGeolocationError = (error): string => {
  let errorMessage

  switch (error.code) {
    case error.PERMISSION_DENIED:
      errorMessage =
        'You must allow this site to access your location or use the option to deliver to someplace else.'
      break

    case error.POSITION_UNAVAILABLE:
      errorMessage = 'Location information is unavailable.'
      break

    case error.TIMEOUT:
      errorMessage = 'The request to get user location timed out.'
      break

    case error.UNKNOWN_ERROR:
      errorMessage = 'An unknown error occurred.'
      break

    default:
      errorMessage =
        'You must allow this site to access your location or use the option to deliver to someplace else.'
      break
  }

  return errorMessage
}

export const getPosition = (): Promise<{
  type: string
  position: GeolocationPosition
}> =>
  new Promise(function (resolve, reject) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({ type: GeolocationStatus.SUCCESS, position })
        },
        (error) => {
          cookie.remove('latitude')
          cookie.remove('longitude')

          reject({
            type: GeolocationStatus.ERROR,
            errorMessage: getGeolocationError(error)
          })
        },
        {
          timeout: 7500,
          enableHighAccuracy: true
        }
      )
    } else {
      reject({ type: GeolocationStatus.NOT_SUPPORT, errorMessage: "Geolocation isn't supported" })
    }
  })

export const geoLocationErrorHandler = (error) => {
  switch (error.type) {
    case GeolocationStatus.NOT_SUPPORT:
      toast.error('Geolocation is not supported by this browser')
      alert('Geolocation is not supported by this browser')
      break

    case GeolocationStatus.ERROR:
      toast.error(error.errorMessage, {
        autoClose: 7000,
        onClick: () => {
          const clientWindow = window.open()

          clientWindow.opener = null
          clientWindow.location =
            'https://docs.buddypunch.com/en/articles/919258-how-to-enable-location-services-for-chrome-safari-edge-and-android-ios-devices-gps-setting'
          clientWindow.target = '_blank'
        }
      })
      break

    default:
      break
  }
}
